import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { useTheme } from "@mui/material/styles";
import DefaultButton from "../simple/DefaultButton";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { BrandContext } from "../../App";
import ProgressBar from "../simple/ProgressBar";
import { useNavigate } from "react-router-dom";

import PageTitle from "../PageTitle/PageTitle";

export default function HomeProgramCard({}) {
  const theme = useTheme();
  const { trainingProgram } = React.useContext(BrandContext);
  const navigate = useNavigate();

  if (!trainingProgram) {
    return (
      <Card
        sx={{
          mb: theme.customSpacing["4xl"],
          padding: theme.containers.paddingDesktop,
          color: theme.palette.text.secondary,
          border: `2px solid ${theme.palette.border.tertiary}`,
          borderRadius: theme.shape.radius,
          textAlign: "center",
          backgroundColor: "transparent",
        }}
      >
        <Typography sx={{ fontWeight: theme.typography.fontWeightMedium }}>
          Your program is still loading...
        </Typography>
        <Typography sx={{ color: theme.palette.text.gray }}>
          If this takes too long, please refresh the page.
        </Typography>
      </Card>
    );
  }

  return (
    <Card
      className="home-program-card"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        mb: theme.customSpacing["4xl"],
        flexGrow: 1,
        color: theme.palette.text.secondary,
        backgroundColor: "#030039",
        border: `1px solid rgba(1, 236, 255, 0.60)`,

        alignItems: "center",
        borderRadius: "8px",
        boxShadow:
          "-8px -8px 20px 0 rgba(1, 236, 255, 0.08), 8px 8px 16px -4px rgba(1, 236, 255, 0.08)",

        [theme.breakpoints.up("md")]: {
          flexDirection: "row",
        },
        [theme.breakpoints.down("md")]: {
          marginBottom: 0,
        },
        "@media (max-width:1080px)": {
          flexDirection: "column",
          alignItems: "initial",
        },
      }}
    >
      {trainingProgram?.image && (
        <Box
          sx={{
            height: "200px",
            width: "100%",
            backgroundColor: "white",
            backgroundImage: `url(${trainingProgram?.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            [theme.breakpoints.up("md")]: {
              width: "40%",
              height: "354px",
            },
            "@media (max-width:1080px)": {
              height: "200px",
              width: "100%",
            },
          }}
        />
      )}
      <CardContent
        sx={{
          flexGrow: 1,
          backgroundColor: "transparent",
          justifyContent: "space-evenly",
          color: theme.palette.text.primary,
          padding: theme.containers.paddingDesktop,
        }}
      >
        {/* <Typography
          gutterBottom
          sx={{
            mb: theme.customSpacing.md,
            fontSize: theme.typography.textMD.fontSize,
            fontWeight: theme.typography.fontWeightLight,
            color: theme.palette.text.gray,
          }}
        >
          Program Title
        </Typography> */}

        <PageTitle text={trainingProgram?.name} variant="h2" />

        <Typography
          sx={{
            mb: theme.customSpacing["3xl"],
            fontSize: "14px",
            color: theme.palette.text.gray,
          }}
        >
          {trainingProgram?.short_description}
        </Typography>
        <ProgressBar trainingProgram={trainingProgram} />
        <DefaultButton
          wideOnMobile
          size="sm"
          onClick={() =>
            navigate(`/dashboard/trainingprogram/${trainingProgram?.id}`)
          }
          endIcon={
            <ArrowForwardRoundedIcon
              sx={{ fontSize: theme.typography.textMD.fontSize }}
            />
          }
        >
          Continue development
        </DefaultButton>
      </CardContent>
    </Card>
  );
}
